/**
 * Iter 99 — generic horizontal swipe wrapper for mobile cards (spec §22).
 * Swipe right → onSwipeRight (confirm/primary), swipe left → onSwipeLeft
 * (more actions). Never the only way to act — callers keep visible buttons.
 */
import { useRef, useState } from "react";

const THRESHOLD = 80;

export default function SwipeableRow({ children, onSwipeRight, onSwipeLeft, rightLabel = "Action", leftLabel = "More", className = "", testId }) {
  const startX = useRef(null);
  const startY = useRef(null);
  const [dx, setDx] = useState(0);

  const onTouchStart = (e) => {
    startX.current = e.touches[0].clientX;
    startY.current = e.touches[0].clientY;
  };
  const onTouchMove = (e) => {
    if (startX.current == null) return;
    const deltaX = e.touches[0].clientX - startX.current;
    const deltaY = e.touches[0].clientY - startY.current;
    if (Math.abs(deltaY) > Math.abs(deltaX)) return;
    const capped = Math.max(-120, Math.min(120, deltaX));
    if ((capped > 0 && !onSwipeRight) || (capped < 0 && !onSwipeLeft)) return;
    setDx(capped);
  };
  const onTouchEnd = () => {
    if (dx > THRESHOLD && onSwipeRight) onSwipeRight();
    else if (dx < -THRESHOLD && onSwipeLeft) onSwipeLeft();
    setDx(0);
    startX.current = null;
  };

  return (
    <div className={`relative overflow-hidden rounded-3xl ${className}`} data-testid={testId}>
      {dx > 8 && (
        <div className="absolute inset-y-0 left-0 w-1/2 rounded-l-3xl bg-emerald-500 flex items-center pl-5 text-white text-sm font-bold">
          {rightLabel}
        </div>
      )}
      {dx < -8 && (
        <div className="absolute inset-y-0 right-0 w-1/2 rounded-r-3xl bg-neutral-700 flex items-center justify-end pr-5 text-white text-sm font-bold">
          {leftLabel}
        </div>
      )}
      <div
        style={{ transform: `translateX(${dx}px)`, transition: dx === 0 ? "transform 0.18s ease" : "none" }}
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
      >
        {children}
      </div>
    </div>
  );
}
